import React from 'react'

import CarrerHero from '../Components/CarrerHero/CarrerHero';
import Jobroles from '../Components/Jobrole/Jobroles';
import TeamSection from '../Components/TeamSection/TeamSection';

import Newsletter from '../Components/Newsletter/Newsletter' ;

const CarrerPage = () => {
  return (
    <div>
     
      <CarrerHero />
      <Jobroles/>
      <TeamSection />
      <Newsletter />
     
      
    </div>
  )
}

export default CarrerPage
